import { useRef, useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Download, QrCode, Copy } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function MenuQRCode() {
  const ref = useRef(null);
  const [tables, setTables] = useState([]);
  const [sel, setSel] = useState("");

  useEffect(() => {
    api.get("/tables").then(({ data }) => {
      const list = data || [];
      setTables(list);
      if (list.length) setSel(list[0].public_token || list[0].id);
    }).catch(() => {});
  }, []);

  const table = tables.find((t) => (t.public_token || t.id) === sel);
  const url = table?.public_token
    ? `${window.location.origin}/menu?t=${table.public_token}`
    : `${window.location.origin}/menu`;

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = `qr-tavolo-${table?.number ?? "menu"}.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copiato"); }
    catch { toast.error("Copia non riuscita"); }
  };

  return (
    <Card className="p-5 rounded-xl flex flex-col sm:flex-row items-center gap-5" data-testid="menu-qr-card">
      <div ref={ref} className="bg-white p-3 rounded-lg border border-border">
        <QRCodeCanvas value={url} size={128} fgColor="#1A1A1A" level="M" includeMargin={false} data-testid="menu-qr-canvas" />
      </div>
      <div className="flex-1 text-center sm:text-left w-full">
        <div className="flex items-center gap-2 justify-center sm:justify-start text-primary">
          <QrCode className="w-5 h-5" />
          <h3 className="font-dash font-semibold text-lg">QR ordinazione per tavolo</h3>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Seleziona il tavolo: il QR (e il link) apre il menù già associato a quel tavolo.
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2 justify-center sm:justify-start">
          <Select value={sel} onValueChange={setSel}>
            <SelectTrigger className="w-48" data-testid="qr-table-select"><SelectValue placeholder="Seleziona tavolo" /></SelectTrigger>
            <SelectContent>
              {tables.map((t) => (
                <SelectItem key={t.id} value={t.public_token || t.id} data-testid={`qr-table-opt-${t.number}`}>
                  {t.name || `Tavolo ${t.number}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <p className="text-xs text-muted-foreground mt-2 break-all" data-testid="qr-table-url">{url}</p>
        <div className="flex gap-2 mt-3 justify-center sm:justify-start">
          <Button onClick={download} variant="outline" className="rounded-full" data-testid="download-qr-button">
            <Download className="w-4 h-4 mr-1" /> Scarica QR
          </Button>
          <Button onClick={copyLink} variant="outline" className="rounded-full" data-testid="copy-qr-link-button">
            <Copy className="w-4 h-4 mr-1" /> Copia link
          </Button>
        </div>
      </div>
    </Card>
  );
}
